import {
  basePost,
  myBasePost
} from "@/utils/request";

// vac查询封禁信息
export function getVacInfo(data) {
  return myBasePost("/steam/getSteamVAC", data);
}

// vac查询库存游戏列表
export function getVacGameList(data) {
  return myBasePost("/steam/getSteamInventoryNew", data);
}

// 失信人信息
export function getDishonestyInfo(data) {
  return myBasePost("/black/getBlackInfo", data);
}

// 失信人查询
export function getSearchDishonestyInfo(data) {
  return myBasePost("/black/getBlackPerson", data);
}